import axios from "axios";

export default {
    methods: {
        getToController(path, message, fnResponse, fnLoading = ()=>{}) {
            axios.get(`${path}`)
                .then(response =>{fnResponse(response)})
                .catch((e) => {
                    console.log(e);
                    this.error_message_flag = true
                    this.error_message_text = `Не удается загрузить ${e}`
                })
                .finally(fnLoading);
        },
        PushToController(method,path,data,message,kind,file,fnLoad){
            const token = document.querySelector('[name=csrf-token]').content;
            axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
            axios({
                method: `${method}`,
                url: `${path}`,
                data: {data: data}
            }).then((response) => {
                if(response.data.error.length == 0) {
                    if(kind == 'basic'){
                        if(file.link == null){
                            this.progress_bar_flag_basic = true;
                            this.SubmitFile(response.data.id, file, kind).then(fnLoad);
                        } else {
                            fnLoad()
                        }
                    }else{
                        if(file.link == null){
                            this.progress_bar_flag_stimulating = true;
                            this.SubmitFile(response.data.id, file, kind).then(fnLoad);
                        } else {
                            fnLoad()
                        }
                    }
                }else{
                    this.progress_bar_flag_basic = false;
                    this.progress_bar_flag_stimulating = false;
                    this.error_message_flag = true;
                }
                return response;
            }).catch((error) => {
                console.log(error);
/*                return error;*/
            });
        },
        async SubmitFile(id, file, kind){
            this.disabled_button = true;
            let formData = new FormData();
            formData.append('id', id);
            formData.append('file', file.file_name);
            const token = document.querySelector('[name=csrf-token]').content
            axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
            await axios({
                method: 'post',
                url: '/file_create',
                headers: {'Content-Type': 'multipart/form-data'},
                data: formData,
                onUploadProgress: e =>{this.progress_bar_percent = Math.min(Math.round(e.loaded * 100 / e.total), 99);}
            }).then((response) => {
                if(response.status == 200 && response.data.error.length == 0){
                }else{
                    this.error_message_flag = true
                    this.error_message_text = response.data.error
                }
                return response;
            }).catch((error) => {
                console.log(error);
            }).finally(()=> {
                switch (kind) {
                    case 'basic':
                        this.progress_bar_flag_basic = false;
                        break;
                    case 'stimulating':
                        this.progress_bar_flag_stimulating = false;
                        break;
                }
                this.progress_bar_percent = 0;
                this.disabled_button = false;
            });
        },
    }
}